export function validatingState(stateV, timeV) {
  return {
    type: stateV,
    time: timeV
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_validating_telephony.js